export default "<p>\r\n  blocktimer works!\r\n</p>\r\n";